import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminAuthService } from '../services/adminService';

const AdminAuthContext = createContext(null);

export const useAdminAuth = () => {
    const context = useContext(AdminAuthContext);
    if (!context) {
        throw new Error('useAdminAuth must be used within AdminAuthProvider');
    }
    return context;
};

export const AdminAuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(() => {
        const saved = localStorage.getItem('admin_user');
        return saved ? JSON.parse(saved) : null;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        const token = localStorage.getItem('admin_token');
        if (!token) {
            setLoading(false);
            return;
        }

        try {
            const data = await adminAuthService.getMe();
            setAdmin(data.admin);
            localStorage.setItem('admin_user', JSON.stringify(data.admin));
        } catch (error) {
            console.error('Admin auth check failed:', error);
            setAdmin(null);
            localStorage.removeItem('admin_token');
            localStorage.removeItem('admin_user');
        } finally {
            setLoading(false);
        }
    };

    const login = async (email, password) => {
        const data = await adminAuthService.login(email, password);
        setAdmin(data.admin);
        return data;
    };

    const logout = async () => {
        try {
            await adminAuthService.logout();
        } finally {
            setAdmin(null);
            localStorage.removeItem('admin_token');
            localStorage.removeItem('admin_user');
        }
    };

    const value = {
        admin,
        loading,
        login,
        logout,
        isAdminAuthenticated: !!admin
    };

    return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
};
